module.exports = __webpack_public_path__ + "img/domestic-helper.35393984.jpg";